(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/* eslint-disable import/no-unresolved */ /**
 * Load front-end scripts and styling common the the entire theme.
 */ /**
 * Core/global configurations
 */ 
var $087f6d04ddbb1bfe$exports = {};
var $84929c977c73e37d$exports = {};
// Save a list of named combobox actions, for future readability
const $36164315e2379fe5$export$15758f03fbd671fd = {
    Close: 0,
    CloseSelect: 1,
    First: 2,
    Last: 3,
    Next: 4,
    Open: 5,
    PageDown: 6,
    PageUp: 7,
    Previous: 8,
    Select: 9,
    Type: 10
};
function $36164315e2379fe5$export$3f23594af5f37336(x, cb) {
    cb(x);
    return x;
}
// filter an array of options against an input string
// returns an array of options that begin with the filter string, case-independent
function $36164315e2379fe5$var$filterOptions(options = [], filter = "", exclude = []) {
    return options.filter((option)=>{
        const matches = option.toLowerCase().indexOf(filter.toLowerCase()) === 0;
        return matches && exclude.indexOf(option) < 0;
    });
}
function $36164315e2379fe5$export$281f462862cb7f64(event, menuOpen) {
    const { key: key, altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey } = event;
    const openKeys = [
        "ArrowDown",
        "ArrowUp",
        "Enter",
        " "
    ]; // all keys that will do the default open action
    // handle opening when closed
    if (!menuOpen && openKeys.includes(key)) return $36164315e2379fe5$export$15758f03fbd671fd.Open;
    // home and end move the selected option when open or closed
    if (key === "Home") return $36164315e2379fe5$export$15758f03fbd671fd.First;
    if (key === "End") return $36164315e2379fe5$export$15758f03fbd671fd.Last;
    // handle typing characters when open or closed
    if (key === "Backspace" || key === "Clear" || key.length === 1 && key !== " " && !altKey && !ctrlKey && !metaKey) return $36164315e2379fe5$export$15758f03fbd671fd.Type;
    // handle keys when open
    if (menuOpen) {
        if (key === "ArrowUp" && altKey) return $36164315e2379fe5$export$15758f03fbd671fd.CloseSelect;
        if (key === "ArrowDown" && !altKey) return $36164315e2379fe5$export$15758f03fbd671fd.Next;
        if (key === "ArrowUp") return $36164315e2379fe5$export$15758f03fbd671fd.Previous;
        if (key === "PageUp") return $36164315e2379fe5$export$15758f03fbd671fd.PageUp;
        if (key === "PageDown") return $36164315e2379fe5$export$15758f03fbd671fd.PageDown;
        if (key === "Escape") return $36164315e2379fe5$export$15758f03fbd671fd.Close;
        if (key === "Enter" || key === " ") return $36164315e2379fe5$export$15758f03fbd671fd.CloseSelect;
    }
}
function $36164315e2379fe5$export$38c59ee1e6710cd8(options, filter, startIndex = 0) {
    const orderedOptions = [
        ...options.slice(startIndex),
        ...options.slice(0, startIndex)
    ];
    const firstMatch = $36164315e2379fe5$var$filterOptions(orderedOptions, filter)[0];
    const allSameLetter = (array)=>array.every((letter)=>letter === array[0]);
    // first check if there is an exact match for the typed string
    if (firstMatch) return options.indexOf(firstMatch);
    // if the same letter is being repeated, cycle through first-letter matches
    if (allSameLetter(filter.split(""))) {
        const matches = $36164315e2379fe5$var$filterOptions(orderedOptions, filter[0]);
        return options.indexOf(matches[0]);
    }
    // if no matches, return -1
    return -1;
}
function $36164315e2379fe5$export$7a0b4d97d7d26057(currentIndex, maxIndex, action) {
    const pageSize = 10; // used for pageup/pagedown
    switch(action){
        case $36164315e2379fe5$export$15758f03fbd671fd.First:
            return 0;
        case $36164315e2379fe5$export$15758f03fbd671fd.Last:
            return maxIndex;
        case $36164315e2379fe5$export$15758f03fbd671fd.Previous:
            return Math.max(0, currentIndex - 1);
        case $36164315e2379fe5$export$15758f03fbd671fd.Next:
            return Math.min(maxIndex, currentIndex + 1);
        case $36164315e2379fe5$export$15758f03fbd671fd.PageUp:
            return Math.max(0, currentIndex - pageSize);
        case $36164315e2379fe5$export$15758f03fbd671fd.PageDown:
            return Math.min(maxIndex, currentIndex + pageSize);
        default:
            return currentIndex;
    }
}
function $36164315e2379fe5$export$b0ee05d02dd6bfe1(element) {
    const bounding = element.getBoundingClientRect();
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function $36164315e2379fe5$export$2bb74740c4e19def(element) {
    return element && element.clientHeight < element.scrollHeight;
}
function $36164315e2379fe5$export$db4948ed580e0dae(activeElement, scrollParent) {
    const { offsetHeight: offsetHeight, offsetTop: offsetTop } = activeElement;
    const { offsetHeight: parentOffsetHeight, scrollTop: scrollTop } = scrollParent;
    const isAbove = offsetTop < scrollTop;
    const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
    if (isAbove) scrollParent.scrollTo(0, offsetTop);
    else if (isBelow) scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
}



let $6fc115490a1646dc$var$idCounter = 0;
/*
 * Select Component
 * Accepts a combobox element and an array of string options
 */ class $6fc115490a1646dc$var$Select {
    constructor(el){
        // element refs
        this.el = el;
        this.labelEl = el.querySelector(".combo-label");
        this.comboEl = el.querySelector("[role=combobox]");
        this.listboxEl = el.querySelector("[role=listbox]");
        this.optionLabels = Array.from(this.listboxEl.children).map((o)=>o.textContent);
        // data
        $6fc115490a1646dc$var$idCounter += 1;
        this.idBase = this.comboEl.id || `combo-${$6fc115490a1646dc$var$idCounter}`;
        // state
        this.activeIndex = 0;
        this.open = false;
        this.searchString = "";
        this.searchTimeout = null;
        // init
        if (el && this.comboEl && this.listboxEl) this.init();
    }
    init() {
        // add event listeners
        this.labelEl?.addEventListener("click", this.onLabelClick.bind(this));
        this.comboEl.addEventListener("blur", this.onComboBlur.bind(this));
        this.listboxEl.addEventListener("focusout", this.onComboBlur.bind(this));
        this.comboEl.addEventListener("click", this.onComboClick.bind(this));
        this.comboEl.addEventListener("keydown", this.onComboKeyDown.bind(this));
        this.listboxEl.querySelectorAll("[role=option]").forEach((optionEl, index)=>{
            optionEl.id = `${this.idBase}-${index}`;
            optionEl.addEventListener("click", (event)=>{
                event.stopPropagation();
                this.onOptionClick(index);
            });
            optionEl.addEventListener("mousedown", this.onOptionMouseDown.bind(this));
        });
    }
    getSearchString(char) {
        // reset typing timeout and start new timeout
        // this allows us to make multiple-letter matches, like a native select
        if (typeof this.searchTimeout === "number") window.clearTimeout(this.searchTimeout);
        this.searchTimeout = window.setTimeout(()=>{
            this.searchString = "";
        }, 500);
        // add most recent letter to saved search string
        this.searchString += char;
        return this.searchString;
    }
    onLabelClick() {
        this.comboEl.focus();
    }
    onComboBlur(event) {
        // do nothing if relatedTarget is contained within listboxEl
        if (this.listboxEl.contains(event.relatedTarget)) return;
        // select current option and close
        if (this.open) {
            this.selectOption(this.activeIndex);
            this.updateMenuState(false, false);
        }
    }
    onComboClick() {
        this.updateMenuState(!this.open, false);
    }
    onComboKeyDown(event) {
        const { key: key } = event;
        const max = this.optionLabels.length - 1;
        const action = (0, $36164315e2379fe5$export$281f462862cb7f64)(event, this.open);
        switch(action){
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).Last:
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).First:
                this.updateMenuState(true);
            // intentional fallthrough
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).Next:
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).Previous:
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).PageUp:
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).PageDown:
                event.preventDefault();
                return this.onOptionChange((0, $36164315e2379fe5$export$7a0b4d97d7d26057)(this.activeIndex, max, action));
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).CloseSelect:
                event.preventDefault();
                this.selectOption(this.activeIndex);
            // intentional fallthrough
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).Close:
                event.preventDefault();
                return this.updateMenuState(false);
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).Type:
                return this.onComboType(key);
            case (0, $36164315e2379fe5$export$15758f03fbd671fd).Open:
                event.preventDefault();
                return this.updateMenuState(true);
            default:
        }
    }
    onComboType(letter) {
        // open the listbox if it is closed
        this.updateMenuState(true);
        // find the index of the first matching option
        const searchString = this.getSearchString(letter);
        const searchIndex = (0, $36164315e2379fe5$export$38c59ee1e6710cd8)(this.optionLabels, searchString, this.activeIndex + 1);
        // if a match was found, go to it
        if (searchIndex >= 0) this.onOptionChange(searchIndex);
        else {
            window.clearTimeout(this.searchTimeout);
            this.searchString = "";
        }
    }
    onOptionChange(index) {
        // update state
        this.activeIndex = index;
        // update aria-activedescendant
        this.comboEl.setAttribute("aria-activedescendant", `${this.idBase}-${index}`);
        // update active option styles
        const options = this.el.querySelectorAll("[role=option]");
        options.forEach((optionEl, optIndex)=>{
            optionEl.dataset.hasFocus = optIndex === index ? "true" : "false";
        });
        // ensure the new option is in view
        if ((0, $36164315e2379fe5$export$2bb74740c4e19def)(this.listboxEl)) (0, $36164315e2379fe5$export$db4948ed580e0dae)(options[index], this.listboxEl);
        // ensure the new option is visible on screen
        // ensure the new option is in view
        if (!(0, $36164315e2379fe5$export$b0ee05d02dd6bfe1)(options[index])) options[index].scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }
    onOptionClick(index) {
        this.onOptionChange(index);
        this.selectOption(index);
        this.updateMenuState(false);
    }
    onOptionMouseDown() {
        // Clicking an option will cause a blur event,
        // but we don't want to perform the default keyboard blur action
        this.ignoreBlur = true;
    }
    selectOption(index) {
        // update state
        this.activeIndex = index;
        // update displayed value
        const selected = this.optionLabels[index];
        this.comboEl.innerText = selected;
        // update aria-selected
        const options = this.el.querySelectorAll("[role=option]");
        [
            ...options
        ].forEach((optionEl)=>{
            optionEl.setAttribute("aria-selected", "false");
        });
        options[index].setAttribute("aria-selected", "true");
        this.el.dispatchEvent(new CustomEvent("select", {
            detail: {
                selectedIndex: this.activeIndex + 1
            }
        }));
    }
    updateMenuState(open, callFocus = true) {
        if (this.open === open) return;
        // update state
        this.open = open;
        // update aria-expanded and styles
        this.comboEl.setAttribute("aria-expanded", `${open}`);
        // update activedescendant
        const activeID = open ? `${this.idBase}-${this.activeIndex}` : "";
        this.comboEl.setAttribute("aria-activedescendant", activeID);
        if (activeID === "") this.listboxEl.querySelectorAll("[role=option]").forEach((optionEl)=>{
            optionEl.dataset.hasFocus = "false";
        });
        if (activeID === "" && !(0, $36164315e2379fe5$export$b0ee05d02dd6bfe1)(this.comboEl)) this.comboEl.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
        // move focus back to the combobox, if needed
        callFocus && this.comboEl.focus();
    }
}
var $6fc115490a1646dc$export$2e2bcd8739ae039 = $6fc115490a1646dc$var$Select;


class $84929c977c73e37d$var$CustomSelect {
    /**
	 * @param {HTMLSelectElement} element
	 */ constructor(element){
        this.selectEl = element;
        this.createCustomSelectElements();
        this.setup();
    }
    setup() {
        this.select = new (0, $6fc115490a1646dc$export$2e2bcd8739ae039)(this.containerEl);
        this.containerEl.addEventListener("select", (e)=>{
            this.selectEl.selectedIndex = e.detail.selectedIndex;
        });
    }
    createCustomSelectElements() {
        const containerEl = document.createElement("div");
        containerEl.classList.add("custom-select");
        containerEl.append((0, $36164315e2379fe5$export$3f23594af5f37336)(document.createElement("button"), (b)=>{
            b.classList.add("custom-select__button");
            b.type = "button";
            b.role = "combobox";
            b.ariaExpanded = false;
            b.ariaHasPopup = "listbox";
            b.tabIndex = 0;
            b.textContent = this.selectEl.firstElementChild.textContent;
        }));
        containerEl.append((0, $36164315e2379fe5$export$3f23594af5f37336)(document.createElement("div"), (menuEl)=>{
            menuEl.classList.add("custom-select__menu");
            menuEl.role = "listbox";
            Array.from(this.selectEl.children).forEach((o)=>{
                if (o.hidden) return;
                const option = document.createElement("li");
                option.classList.add("custom-select__menu-option");
                option.append((0, $36164315e2379fe5$export$3f23594af5f37336)(document.createElement("button"), (ob)=>{
                    ob.classList.add("custom-select__menu-option-button");
                    ob.type = "button";
                    ob.role = "option";
                    ob.ariaSelected = false;
                    ob.textContent = o.textContent;
                }));
                menuEl.append(option);
            });
        }));
        this.containerEl = containerEl;
        this.selectEl.after(this.containerEl);
    }
}
document.querySelectorAll(".form-field__input--select").forEach((selectEl)=>{
    const customSelect = new $84929c977c73e37d$var$CustomSelect(selectEl);
    selectEl._customSelect = customSelect;
});
document.querySelectorAll(".gfield--type-select select").forEach((selectEl)=>{
    const containerEl = selectEl.closest(".gfield--type-select");
    const labelEl = containerEl.querySelector(".gform-field-label");
    containerEl.classList.add("gfield--type-custom-select");
    if (labelEl) {
        const placeholderOption = document.createElement("option");
        placeholderOption.value = "";
        placeholderOption.textContent = labelEl.textContent;
        placeholderOption.hidden = true;
        selectEl.prepend(placeholderOption);
    }
    const customSelect = new $84929c977c73e37d$var$CustomSelect(selectEl);
    selectEl._customSelect = customSelect;
});


var $ebdfe03c08ae09ab$exports = {};
document.querySelectorAll(".gform-body input, .gform-body textarea").forEach((inputEl)=>{
    inputEl.classList.add("gfield--empty");
    inputEl.addEventListener("input", (e)=>{
        inputEl.classList.toggle("gfield--empty", e.target.value.length === 0);
    });
});


var $27992f293b259f68$exports = {};
(()=>{
    "use strict";
    var t = {
        701: (t)=>{
            let e = 0;
            t.exports = {
                incr: ()=>++e,
                decr: ()=>--e,
                curr: ()=>e
            };
        },
        941: (t)=>{
            t.exports = (t, e, r = "")=>{
                const n = /url\(['"]?#([\w:.-]+)['"]?\)/g, a = /#([\w:.-]+)/g;
                return e.match(n) && (e = e.replace(n, function(e, r) {
                    return t[r] ? `url(#${t[r]})` : e;
                })), [
                    "href",
                    "xlink:href"
                ].includes(r) && e.match(a) && (e = e.replace(a, function(e, r) {
                    return t[r] ? `#${t[r]}` : e;
                })), e;
            };
        },
        905: (t)=>{
            t.exports = (t, e, r)=>{
                const n = new RegExp("([^\r\n,{}]+)(,(?=[^}]*{)|s*{)", "g");
                return t.replace(n, function(t, n, a) {
                    if (n.match(/^\s*(@media|@.*keyframes|to|from|@font-face|1?[0-9]?[0-9])/)) return n + a;
                    const o = n.match(/#(\w+)/);
                    return o && r[o[1]] && (n = n.replace(o[0], `#${r[o[1]]}`)), (n = n.replace(/^(\s*)/, "$1" + e + " ")) + a;
                });
            };
        },
        678: (t, e, r)=>{
            function n(t) {
                return new Promise((e, r)=>{
                    t.oncomplete = t.onsuccess = ()=>e(t.result), t.onabort = t.onerror = ()=>r(t.error);
                });
            }
            function a(t, e) {
                const r = indexedDB.open(t);
                r.onupgradeneeded = ()=>r.result.createObjectStore(e);
                const a = n(r);
                return (t, r)=>a.then((n)=>r(n.transaction(e, t).objectStore(e)));
            }
            let o;
            function s() {
                return o || (o = a("keyval-store", "keyval")), o;
            }
            function i(t, e = s()) {
                return e("readonly", (e)=>n(e.get(t)));
            }
            function c(t, e, r = s()) {
                return r("readwrite", (r)=>(r.put(e, t), n(r.transaction)));
            }
            function u(t, e = s()) {
                return e("readwrite", (e)=>(t.forEach((t)=>e.put(t[1], t[0])), n(e.transaction)));
            }
            function l(t, e = s()) {
                return e("readonly", (e)=>Promise.all(t.map((t)=>n(e.get(t)))));
            }
            function d(t, e, r = s()) {
                return r("readwrite", (r)=>new Promise((a, o)=>{
                        r.get(t).onsuccess = function() {
                            try {
                                r.put(e(this.result), t), a(n(r.transaction));
                            } catch (t) {
                                o(t);
                            }
                        };
                    }));
            }
            function f(t, e = s()) {
                return e("readwrite", (e)=>(e.delete(t), n(e.transaction)));
            }
            function h(t, e = s()) {
                return e("readwrite", (e)=>(t.forEach((t)=>e.delete(t)), n(e.transaction)));
            }
            function b(t = s()) {
                return t("readwrite", (t)=>(t.clear(), n(t.transaction)));
            }
            function g(t, e) {
                return t.openCursor().onsuccess = function() {
                    this.result && (e(this.result), this.result.continue());
                }, n(t.transaction);
            }
            function p(t = s()) {
                return t("readonly", (t)=>{
                    if (t.getAllKeys) return n(t.getAllKeys());
                    const e = [];
                    return g(t, (t)=>e.push(t.key)).then(()=>e);
                });
            }
            function y(t = s()) {
                return t("readonly", (t)=>{
                    if (t.getAll) return n(t.getAll());
                    const e = [];
                    return g(t, (t)=>e.push(t.value)).then(()=>e);
                });
            }
            function m(t = s()) {
                return t("readonly", (e)=>{
                    if (e.getAll && e.getAllKeys) return Promise.all([
                        n(e.getAllKeys()),
                        n(e.getAll())
                    ]).then(([t, e])=>t.map((t, r)=>[
                                t,
                                e[r]
                            ]));
                    const r = [];
                    return t("readonly", (t)=>g(t, (t)=>r.push([
                                t.key,
                                t.value
                            ])).then(()=>r));
                });
            }
            r.r(e), r.d(e, {
                clear: ()=>b,
                createStore: ()=>a,
                del: ()=>f,
                delMany: ()=>h,
                entries: ()=>m,
                get: ()=>i,
                getMany: ()=>l,
                keys: ()=>p,
                promisifyRequest: ()=>n,
                set: ()=>c,
                setMany: ()=>u,
                update: ()=>d,
                values: ()=>y
            });
        }
    }, e = {};
    function r(n) {
        var a = e[n];
        if (void 0 !== a) return a.exports;
        var o = e[n] = {
            exports: {}
        };
        return t[n](o, o.exports, r), o.exports;
    }
    r.d = (t, e)=>{
        for(var n in e)r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: e[n]
        });
    }, r.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), r.r = (t)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, (()=>{
        const { get: t, set: e, del: n, entries: a } = r(678), o = r(905), s = r(941), i = r(701), c = [], u = {}, l = (t, e, r)=>{
            const { enableJs: n, disableUniqueIds: a, disableCssScoping: l, spriteIconId: d } = e, f = !!d, h = (new DOMParser).parseFromString(r, "text/html"), b = f ? h.getElementById(d) : h.querySelector("svg"), g = (()=>{
                if (c.length) return c;
                for(const t in document.body)t.startsWith("on") && c.push(t);
                return c.push("onbegin", "onend", "onrepeat"), c.push("onfocusin", "onfocusout", "onbounce", "onfinish", "onshow"), c;
            })(), p = u[t.getAttribute("data-id")] || new Set, y = t.getAttribute("data-id") || `svg-loader_${i.incr()}`, m = {};
            if (a || Array.from(b.querySelectorAll("[id]")).forEach((t)=>{
                const e = t.getAttribute("id"), r = `${e}_${i.incr()}`;
                t.setAttribute("id", r), m[e] = r;
            }), Array.from(b.querySelectorAll("*")).concat(b).forEach((e)=>{
                if ("script" === e.tagName) {
                    if (e.remove(), !n) return;
                    {
                        const r = document.createElement("script");
                        r.appendChild(e.childNodes[0]), t.appendChild(r);
                    }
                }
                const r = [];
                for(let t = 0; t < e.attributes.length; t++){
                    const { name: a, value: o } = e.attributes[t], i = s(m, o, a);
                    o !== i && e.setAttribute(a, i), !g.includes(a.toLowerCase()) || n ? [
                        "href",
                        "xlink:href",
                        "values"
                    ].includes(a) && o.startsWith("javascript") && !n && r.push(a) : r.push(a);
                }
                if (r.forEach((t)=>e.removeAttribute(t)), "style" === e.tagName && !l) {
                    let t = o(e.innerHTML, `[data-id="${y}"]`, m);
                    t = s(m, t), t !== e.innerHTML && (e.innerHTML = t);
                }
            }), t.innerHTML = d ? b.outerHTML : b.innerHTML, !f) for(let e = 0; e < b.attributes.length; e++){
                const { name: r, value: n } = b.attributes[e];
                t.getAttribute(r) && !p.has(r) || (p.add(r), t.setAttribute(r, n));
            }
            u[y] = p, t.setAttribute("data-id", y);
            const v = new CustomEvent("iconload", {
                bubbles: !0
            });
            if (t.dispatchEvent(v), t.getAttribute("oniconload")) {
                t.setAttribute("onauxclick", t.getAttribute("oniconload"));
                const e = new CustomEvent("auxclick", {
                    bubbles: !1,
                    view: window
                });
                t.dispatchEvent(e), t.removeAttribute("onauxclick");
            }
        }, d = {}, f = {}, h = async (r)=>{
            const a = new URL(r.getAttribute("data-src"), globalThis.location), o = a.toString().replace(a.hash, ""), s = a.hash.replace("#", ""), i = r.getAttribute("data-cache"), c = "enabled" === r.getAttribute("data-js"), u = "disabled" === r.getAttribute("data-unique-ids"), b = "disabled" === r.getAttribute("data-css-scoping"), g = await (async (e)=>{
                let r;
                try {
                    r = await t(`loader_${e}`);
                } catch (t) {}
                if (!r) try {
                    r = localStorage.getItem(`loader_${e}`);
                } catch (t) {}
                if (r) return r = JSON.parse(r), Date.now() < r.expiry ? r.data : void n(`loader_${e}`);
            })(o), p = "disabled" !== i, y = l.bind(self, r, {
                enableJs: c,
                disableUniqueIds: u,
                disableCssScoping: b,
                spriteIconId: s
            });
            if (f[o] || p && g) {
                const t = f[o] || g;
                y(t);
            } else {
                if (d[o]) return void setTimeout(()=>h(r), 20);
                d[o] = !0, fetch(o).then((t)=>{
                    if (!t.ok) throw Error(`Request for '${o}' returned ${t.status} (${t.statusText})`);
                    return t.text();
                }).then((t)=>{
                    const r = t.toLowerCase().trim();
                    if (!(r.startsWith("<svg") || r.startsWith("<?xml") || r.startsWith("<!doctype"))) throw Error(`Resource '${o}' returned an invalid SVG file`);
                    p && (async (t, r, n)=>{
                        const a = parseInt(n, 10), o = JSON.stringify({
                            data: r,
                            expiry: Date.now() + (Number.isNaN(a) ? 2592e6 : 1e3 * a)
                        });
                        try {
                            await e(`loader_${t}`, o);
                        } catch (e) {
                            try {
                                localStorage.setItem(`loader_${t}`, o);
                            } catch (t) {
                                console.warn("Failed to set cache: ", t);
                            }
                        }
                    })(o, t, i), f[o] = t, y(t);
                }).catch((t)=>{
                    console.error(t);
                }).finally(()=>{
                    delete d[o];
                });
            }
        };
        let b;
        globalThis.IntersectionObserver && (b = new IntersectionObserver((t)=>{
            t.forEach((t)=>{
                t.isIntersecting && (h(t.target), b.unobserve(t.target));
            });
        }, {
            rootMargin: "1200px"
        }));
        const g = [];
        function p() {
            Array.from(document.querySelectorAll("svg[data-src]:not([data-id])")).forEach((t)=>{
                -1 === g.indexOf(t) && (g.push(t), "lazy" === t.getAttribute("data-loading") ? b.observe(t) : h(t));
            });
        }
        let y = !1;
        if (globalThis.addEventListener) {
            const m = setInterval(()=>{
                p();
            }, 100);
            function v() {
                clearInterval(m), p(), y || (y = !0, new MutationObserver((t)=>{
                    t.some((t)=>Array.from(t.addedNodes).some((t)=>t.nodeType === Node.ELEMENT_NODE && (t.getAttribute("data-src") && !t.getAttribute("data-id") || t.querySelector("svg[data-src]:not([data-id])")))) && p(), t.forEach((t)=>{
                        "attributes" === t.type && h(t.target);
                    });
                }).observe(document.documentElement, {
                    attributeFilter: [
                        "data-src"
                    ],
                    attributes: !0,
                    childList: !0,
                    subtree: !0
                }));
            }
            "interactive" === document.readyState ? v() : globalThis.addEventListener("DOMContentLoaded", ()=>{
                v();
            });
        }
        globalThis.SVGLoader = {}, globalThis.SVGLoader.destroyCache = async ()=>{
            try {
                const t = await a();
                for (const e of t)e[0].startsWith("loader_") && await n(e[0]);
            } catch (t) {}
            Object.keys(localStorage).forEach((t)=>{
                t.startsWith("loader_") && localStorage.removeItem(t);
            });
        };
    })();
})(); //# sourceMappingURL=svg-loader.min.js.map


window.addEventListener("iconload", (event)=>{
    event.target.classList.add("inline-svg--loaded");
});


var $155461a1578c116a$exports = {};
const $155461a1578c116a$var$initVideo = (videoEl, options = {})=>{
    if (options.targetAspectRatio !== "auto") videoEl.addEventListener("loadedmetadata", ()=>{
        const videoAspectRatio = videoEl.videoWidth / videoEl.videoHeight;
        const [ta, tb] = options.targetAspectRatio.split("/");
        const targetAspectRatio = tb ? parseFloat(ta) / parseFloat(tb) : parseFloat(ta);
        const widthPercent = Math.round(videoAspectRatio / targetAspectRatio * 10000) / 100;
        options.mediaWrapperEl.style.setProperty("--media-video-correction", `${widthPercent}%`);
    });
};
const $155461a1578c116a$var$initMedia = (mediaWrapperEl)=>{
    const mediaEl = mediaWrapperEl.querySelector(".ona-media__media");
    if (mediaEl && mediaEl.tagName === "VIDEO") $155461a1578c116a$var$initVideo(mediaEl, {
        mediaWrapperEl: mediaWrapperEl,
        targetAspectRatio: mediaWrapperEl.style.getPropertyValue("--media-aspect-ratio")
    });
};
document.querySelectorAll(".ona-media").forEach((mediaEl)=>$155461a1578c116a$var$initMedia(mediaEl));


var $57b5d2af5de26002$exports = {};
let $57b5d2af5de26002$var$themeVariant = document.cookie.split("; ").find((row)=>row.startsWith("occasions_theme="))?.split("=")[1] || "dark";
const $57b5d2af5de26002$var$mobileMenuButton = document.querySelector(".site-menu__mobile-toggle-button");
const $57b5d2af5de26002$var$themeSwitchButton = document.querySelector(".site-menu__toggle-button");
/**
 * Toggle dark/light theme
 */ const $57b5d2af5de26002$var$toggleTheme = ()=>{
    $57b5d2af5de26002$var$themeVariant = $57b5d2af5de26002$var$themeVariant === "dark" ? "light" : "dark";
    document.documentElement.classList.toggle("site--light-theme", $57b5d2af5de26002$var$themeVariant === "light");
    document.cookie = `occasions_theme=${$57b5d2af5de26002$var$themeVariant}; path=/`;
};
const $57b5d2af5de26002$var$updateThemeToggleButton = ()=>{
    const [darkLabel, lightLabel] = $57b5d2af5de26002$var$themeSwitchButton.children;
    const isOn = $57b5d2af5de26002$var$themeVariant === "light";
    darkLabel.classList.toggle("site-menu__toggle-button-label--active", !isOn);
    lightLabel.classList.toggle("site-menu__toggle-button-label--active", isOn);
    $57b5d2af5de26002$var$themeSwitchButton.ariaChecked = isOn;
};
/**
 * Set up menu ARIA
 */ const $57b5d2af5de26002$var$setupMenuAria = ()=>{
    const menuEl = document.querySelector(".site-menu__nav").firstElementChild;
    const siteHeaderEl = document.querySelector(".site-header");
    menuEl.querySelectorAll(".menu-item-has-children").forEach((branchItemEl)=>{
        const subMenuEl = document.querySelector(".sub-menu");
        const itemId = Array.from(branchItemEl.classList.values()).find((className)=>/^menu-item-\d+$/.test(className));
        branchItemEl.id = itemId;
        subMenuEl.id = `${itemId}-submenu`;
        subMenuEl.ariaHidden = "true";
        branchItemEl.setAttribute("aria-controls", subMenuEl.id);
        branchItemEl.addEventListener("mouseenter", ()=>{
            branchItemEl.ariaExpanded = "true";
            subMenuEl.ariaHidden = "false";
            siteHeaderEl.style.setProperty("--h-menu-extra", `calc(${branchItemEl.querySelector(".sub-menu").offsetHeight}px + 2rem)`);
        });
        branchItemEl.addEventListener("mouseleave", ()=>{
            branchItemEl.ariaExpanded = "false";
            subMenuEl.ariaHidden = "true";
            siteHeaderEl.style.setProperty("--h-menu-extra", "0px");
        });
    });
};
/**
 * Toggle mobile menu
 */ const $57b5d2af5de26002$var$toggleMobileMainMenu = ()=>{
    const container = document.querySelector(".site-menu__container");
    $57b5d2af5de26002$var$mobileMenuButton.classList.toggle("site-menu__mobile-toggle-button--cross");
    container.classList.toggle("site-menu__container--mobile-visible");
};
/**
 * Set up main menu.
 */ const $57b5d2af5de26002$var$mainMenu = ()=>{
    $57b5d2af5de26002$var$setupMenuAria();
    if ($57b5d2af5de26002$var$themeSwitchButton) $57b5d2af5de26002$var$themeSwitchButton.addEventListener("click", ()=>{
        $57b5d2af5de26002$var$toggleTheme();
        $57b5d2af5de26002$var$updateThemeToggleButton();
    });
    if ($57b5d2af5de26002$var$mobileMenuButton) $57b5d2af5de26002$var$mobileMenuButton.addEventListener("click", ()=>{
        $57b5d2af5de26002$var$toggleMobileMainMenu();
    });
};
// run it!
$57b5d2af5de26002$var$mainMenu();
$57b5d2af5de26002$var$updateThemeToggleButton();


var $0af0c46dafe28aa0$exports = {};
let $0af0c46dafe28aa0$var$lastTimestamp = 0;
let $0af0c46dafe28aa0$var$lastWindowScroll = -1;
const $0af0c46dafe28aa0$var$doParallax = (timestamp)=>{
    if (timestamp > $0af0c46dafe28aa0$var$lastTimestamp + 32) {
        if ($0af0c46dafe28aa0$var$lastWindowScroll !== window.scrollY) {
            document.body.style.setProperty("--occ-parallax-window-scroll", `${window.scrollY}px`);
            $0af0c46dafe28aa0$var$lastWindowScroll = window.scrollY;
        }
        $0af0c46dafe28aa0$var$lastTimestamp = timestamp;
    }
    window.requestAnimationFrame($0af0c46dafe28aa0$var$doParallax);
};
const $0af0c46dafe28aa0$var$updateScrollPosition = (element)=>{
    element.style.setProperty("--occ-parallax-scroll-position", `${element.offsetTop}px`);
};
const $0af0c46dafe28aa0$var$resizeObserver = new ResizeObserver((entries)=>{
    for (const entry of entries)$0af0c46dafe28aa0$var$updateScrollPosition(entry.target);
});
document.querySelectorAll(".occ-parallax-container").forEach((element)=>{
    $0af0c46dafe28aa0$var$resizeObserver.observe(element);
});
$0af0c46dafe28aa0$var$doParallax();


var $9ed9184e974deeb2$exports = {};

$parcel$export($9ed9184e974deeb2$exports, "initSlider", function () { return $9ed9184e974deeb2$export$25bca1bc22cc4f64; });
function $871ea46ce85d65bc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $871ea46ce85d65bc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $871ea46ce85d65bc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $871ea46ce85d65bc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $871ea46ce85d65bc$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $871ea46ce85d65bc$var$CREATED = 1;
var $871ea46ce85d65bc$var$MOUNTED = 2;
var $871ea46ce85d65bc$var$IDLE = 3;
var $871ea46ce85d65bc$var$MOVING = 4;
var $871ea46ce85d65bc$var$SCROLLING = 5;
var $871ea46ce85d65bc$var$DRAGGING = 6;
var $871ea46ce85d65bc$var$DESTROYED = 7;
var $871ea46ce85d65bc$var$STATES = {
    CREATED: $871ea46ce85d65bc$var$CREATED,
    MOUNTED: $871ea46ce85d65bc$var$MOUNTED,
    IDLE: $871ea46ce85d65bc$var$IDLE,
    MOVING: $871ea46ce85d65bc$var$MOVING,
    SCROLLING: $871ea46ce85d65bc$var$SCROLLING,
    DRAGGING: $871ea46ce85d65bc$var$DRAGGING,
    DESTROYED: $871ea46ce85d65bc$var$DESTROYED
};
function $871ea46ce85d65bc$var$empty(array) {
    array.length = 0;
}
function $871ea46ce85d65bc$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $871ea46ce85d65bc$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($871ea46ce85d65bc$var$slice(arguments, 1)));
}
var $871ea46ce85d65bc$var$nextTick = setTimeout;
var $871ea46ce85d65bc$var$noop = function noop() {};
function $871ea46ce85d65bc$var$raf(func) {
    return requestAnimationFrame(func);
}
function $871ea46ce85d65bc$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $871ea46ce85d65bc$var$isObject(subject) {
    return !$871ea46ce85d65bc$var$isNull(subject) && $871ea46ce85d65bc$var$typeOf("object", subject);
}
var $871ea46ce85d65bc$var$isArray = Array.isArray;
var $871ea46ce85d65bc$var$isFunction = $871ea46ce85d65bc$var$apply($871ea46ce85d65bc$var$typeOf, "function");
var $871ea46ce85d65bc$var$isString = $871ea46ce85d65bc$var$apply($871ea46ce85d65bc$var$typeOf, "string");
var $871ea46ce85d65bc$var$isUndefined = $871ea46ce85d65bc$var$apply($871ea46ce85d65bc$var$typeOf, "undefined");
function $871ea46ce85d65bc$var$isNull(subject) {
    return subject === null;
}
function $871ea46ce85d65bc$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $871ea46ce85d65bc$var$toArray(value) {
    return $871ea46ce85d65bc$var$isArray(value) ? value : [
        value
    ];
}
function $871ea46ce85d65bc$var$forEach(values, iteratee) {
    $871ea46ce85d65bc$var$toArray(values).forEach(iteratee);
}
function $871ea46ce85d65bc$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $871ea46ce85d65bc$var$push(array, items) {
    array.push.apply(array, $871ea46ce85d65bc$var$toArray(items));
    return array;
}
function $871ea46ce85d65bc$var$toggleClass(elm, classes, add) {
    if (elm) $871ea46ce85d65bc$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $871ea46ce85d65bc$var$addClass(elm, classes) {
    $871ea46ce85d65bc$var$toggleClass(elm, $871ea46ce85d65bc$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $871ea46ce85d65bc$var$append(parent, children) {
    $871ea46ce85d65bc$var$forEach(children, parent.appendChild.bind(parent));
}
function $871ea46ce85d65bc$var$before(nodes, ref) {
    $871ea46ce85d65bc$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $871ea46ce85d65bc$var$matches(elm, selector) {
    return $871ea46ce85d65bc$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $871ea46ce85d65bc$var$children(parent, selector) {
    var children2 = parent ? $871ea46ce85d65bc$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $871ea46ce85d65bc$var$matches(child, selector);
    }) : children2;
}
function $871ea46ce85d65bc$var$child(parent, selector) {
    return selector ? $871ea46ce85d65bc$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $871ea46ce85d65bc$var$ownKeys = Object.keys;
function $871ea46ce85d65bc$var$forOwn(object, iteratee, right) {
    if (object) (right ? $871ea46ce85d65bc$var$ownKeys(object).reverse() : $871ea46ce85d65bc$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $871ea46ce85d65bc$var$assign(object) {
    $871ea46ce85d65bc$var$slice(arguments, 1).forEach(function(source) {
        $871ea46ce85d65bc$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $871ea46ce85d65bc$var$merge(object) {
    $871ea46ce85d65bc$var$slice(arguments, 1).forEach(function(source) {
        $871ea46ce85d65bc$var$forOwn(source, function(value, key) {
            if ($871ea46ce85d65bc$var$isArray(value)) object[key] = value.slice();
            else if ($871ea46ce85d65bc$var$isObject(value)) object[key] = $871ea46ce85d65bc$var$merge({}, $871ea46ce85d65bc$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $871ea46ce85d65bc$var$omit(object, keys) {
    $871ea46ce85d65bc$var$forEach(keys || $871ea46ce85d65bc$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $871ea46ce85d65bc$var$removeAttribute(elms, attrs) {
    $871ea46ce85d65bc$var$forEach(elms, function(elm) {
        $871ea46ce85d65bc$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $871ea46ce85d65bc$var$setAttribute(elms, attrs, value) {
    if ($871ea46ce85d65bc$var$isObject(attrs)) $871ea46ce85d65bc$var$forOwn(attrs, function(value2, name) {
        $871ea46ce85d65bc$var$setAttribute(elms, name, value2);
    });
    else $871ea46ce85d65bc$var$forEach(elms, function(elm) {
        $871ea46ce85d65bc$var$isNull(value) || value === "" ? $871ea46ce85d65bc$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $871ea46ce85d65bc$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $871ea46ce85d65bc$var$isString(attrs) ? $871ea46ce85d65bc$var$addClass(elm, attrs) : $871ea46ce85d65bc$var$setAttribute(elm, attrs);
    parent && $871ea46ce85d65bc$var$append(parent, elm);
    return elm;
}
function $871ea46ce85d65bc$var$style(elm, prop, value) {
    if ($871ea46ce85d65bc$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$871ea46ce85d65bc$var$isNull(value)) elm.style[prop] = "" + value;
}
function $871ea46ce85d65bc$var$display(elm, display2) {
    $871ea46ce85d65bc$var$style(elm, "display", display2);
}
function $871ea46ce85d65bc$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $871ea46ce85d65bc$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $871ea46ce85d65bc$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $871ea46ce85d65bc$var$rect(target) {
    return target.getBoundingClientRect();
}
function $871ea46ce85d65bc$var$remove(nodes) {
    $871ea46ce85d65bc$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $871ea46ce85d65bc$var$parseHtml(html) {
    return $871ea46ce85d65bc$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $871ea46ce85d65bc$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $871ea46ce85d65bc$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $871ea46ce85d65bc$var$queryAll(parent, selector) {
    return selector ? $871ea46ce85d65bc$var$slice(parent.querySelectorAll(selector)) : [];
}
function $871ea46ce85d65bc$var$removeClass(elm, classes) {
    $871ea46ce85d65bc$var$toggleClass(elm, classes, false);
}
function $871ea46ce85d65bc$var$timeOf(e) {
    return e.timeStamp;
}
function $871ea46ce85d65bc$var$unit(value) {
    return $871ea46ce85d65bc$var$isString(value) ? value : value ? value + "px" : "";
}
var $871ea46ce85d65bc$var$PROJECT_CODE = "splide";
var $871ea46ce85d65bc$var$DATA_ATTRIBUTE = "data-" + $871ea46ce85d65bc$var$PROJECT_CODE;
function $871ea46ce85d65bc$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $871ea46ce85d65bc$var$PROJECT_CODE + "] " + (message || ""));
}
var $871ea46ce85d65bc$var$min = Math.min, $871ea46ce85d65bc$var$max = Math.max, $871ea46ce85d65bc$var$floor = Math.floor, $871ea46ce85d65bc$var$ceil = Math.ceil, $871ea46ce85d65bc$var$abs = Math.abs;
function $871ea46ce85d65bc$var$approximatelyEqual(x, y, epsilon) {
    return $871ea46ce85d65bc$var$abs(x - y) < epsilon;
}
function $871ea46ce85d65bc$var$between(number, x, y, exclusive) {
    var minimum = $871ea46ce85d65bc$var$min(x, y);
    var maximum = $871ea46ce85d65bc$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $871ea46ce85d65bc$var$clamp(number, x, y) {
    var minimum = $871ea46ce85d65bc$var$min(x, y);
    var maximum = $871ea46ce85d65bc$var$max(x, y);
    return $871ea46ce85d65bc$var$min($871ea46ce85d65bc$var$max(minimum, number), maximum);
}
function $871ea46ce85d65bc$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $871ea46ce85d65bc$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $871ea46ce85d65bc$var$format(string, replacements) {
    $871ea46ce85d65bc$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $871ea46ce85d65bc$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $871ea46ce85d65bc$var$ids = {};
function $871ea46ce85d65bc$var$uniqueId(prefix) {
    return "" + prefix + $871ea46ce85d65bc$var$pad($871ea46ce85d65bc$var$ids[prefix] = ($871ea46ce85d65bc$var$ids[prefix] || 0) + 1);
}
function $871ea46ce85d65bc$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $871ea46ce85d65bc$var$forEach(targets, function(target) {
            target && $871ea46ce85d65bc$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $871ea46ce85d65bc$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $871ea46ce85d65bc$export$d300dc1a2634364b = "mounted";
var $871ea46ce85d65bc$export$d8dac49b4532735a = "ready";
var $871ea46ce85d65bc$export$2aa493d7c3275167 = "move";
var $871ea46ce85d65bc$export$fe5802204b967f0d = "moved";
var $871ea46ce85d65bc$export$5adb665701eda1ce = "click";
var $871ea46ce85d65bc$export$92e3eae133acac4c = "active";
var $871ea46ce85d65bc$export$6bcbb81035c12cea = "inactive";
var $871ea46ce85d65bc$export$6a5b3445e4066a53 = "visible";
var $871ea46ce85d65bc$export$8c5c7a21d54563e9 = "hidden";
var $871ea46ce85d65bc$export$7f4701ac5e05e39f = "refresh";
var $871ea46ce85d65bc$export$db40ab7c0855fa5c = "updated";
var $871ea46ce85d65bc$export$7e019dae5103a285 = "resize";
var $871ea46ce85d65bc$export$d637eba1e9e28482 = "resized";
var $871ea46ce85d65bc$export$e84bf5065c9087ac = "drag";
var $871ea46ce85d65bc$export$8e9f636d2c722196 = "dragging";
var $871ea46ce85d65bc$export$90ea576bd3fdeb60 = "dragged";
var $871ea46ce85d65bc$export$49801896908b5e33 = "scroll";
var $871ea46ce85d65bc$export$ff8164bff3202b9 = "scrolled";
var $871ea46ce85d65bc$export$6cbac5b662a31e1b = "overflow";
var $871ea46ce85d65bc$export$88c4cf7419e470cd = "destroy";
var $871ea46ce85d65bc$export$8647f6b043e04e9d = "arrows:mounted";
var $871ea46ce85d65bc$export$d467f9343b961f75 = "arrows:updated";
var $871ea46ce85d65bc$export$bf89a4e4349c9778 = "pagination:mounted";
var $871ea46ce85d65bc$export$eb2019082ed6de0b = "pagination:updated";
var $871ea46ce85d65bc$export$84015c33508f94ec = "navigation:mounted";
var $871ea46ce85d65bc$export$23663268a31b79e2 = "autoplay:play";
var $871ea46ce85d65bc$export$185723258309b608 = "autoplay:playing";
var $871ea46ce85d65bc$export$16a1e4f3d0368265 = "autoplay:pause";
var $871ea46ce85d65bc$export$9f64346e17f0ec8e = "lazyload:loaded";
var $871ea46ce85d65bc$export$6d5af59619d10e6a = "sk";
var $871ea46ce85d65bc$export$f0af896383d5adff = "sh";
var $871ea46ce85d65bc$export$28dea85f216954dc = "ei";
function $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $871ea46ce85d65bc$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $871ea46ce85d65bc$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $871ea46ce85d65bc$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $871ea46ce85d65bc$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($871ea46ce85d65bc$export$88c4cf7419e470cd, binder.destroy);
    return $871ea46ce85d65bc$var$assign(binder, {
        bus: bus,
        on: on,
        off: $871ea46ce85d65bc$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $871ea46ce85d65bc$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $871ea46ce85d65bc$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $871ea46ce85d65bc$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $871ea46ce85d65bc$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $871ea46ce85d65bc$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $871ea46ce85d65bc$var$includes($871ea46ce85d65bc$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $871ea46ce85d65bc$export$efff0f5979573c99(func, duration) {
    var interval = $871ea46ce85d65bc$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $871ea46ce85d65bc$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $871ea46ce85d65bc$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $871ea46ce85d65bc$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $871ea46ce85d65bc$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($871ea46ce85d65bc$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $871ea46ce85d65bc$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $871ea46ce85d65bc$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($871ea46ce85d65bc$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $871ea46ce85d65bc$var$merge(options, reducedMotion) : $871ea46ce85d65bc$var$omit(options, $871ea46ce85d65bc$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $871ea46ce85d65bc$var$merge(options, opts);
        base && $871ea46ce85d65bc$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($871ea46ce85d65bc$var$CREATED)) Splide2.emit($871ea46ce85d65bc$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $871ea46ce85d65bc$var$ARROW = "Arrow";
var $871ea46ce85d65bc$var$ARROW_LEFT = $871ea46ce85d65bc$var$ARROW + "Left";
var $871ea46ce85d65bc$var$ARROW_RIGHT = $871ea46ce85d65bc$var$ARROW + "Right";
var $871ea46ce85d65bc$var$ARROW_UP = $871ea46ce85d65bc$var$ARROW + "Up";
var $871ea46ce85d65bc$var$ARROW_DOWN = $871ea46ce85d65bc$var$ARROW + "Down";
var $871ea46ce85d65bc$export$373e92e0788ff06e = "ltr";
var $871ea46ce85d65bc$export$850f7749a2909601 = "rtl";
var $871ea46ce85d65bc$export$97170d9824b89709 = "ttb";
var $871ea46ce85d65bc$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $871ea46ce85d65bc$var$ARROW_UP,
        $871ea46ce85d65bc$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $871ea46ce85d65bc$var$ARROW_DOWN,
        $871ea46ce85d65bc$var$ARROW_LEFT
    ]
};
function $871ea46ce85d65bc$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $871ea46ce85d65bc$export$850f7749a2909601 && !axisOnly ? 1 : direction === $871ea46ce85d65bc$export$97170d9824b89709 ? 0 : -1;
        return $871ea46ce85d65bc$var$ORIENTATION_MAP[prop] && $871ea46ce85d65bc$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $871ea46ce85d65bc$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $871ea46ce85d65bc$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $871ea46ce85d65bc$var$ROLE = "role";
var $871ea46ce85d65bc$var$TAB_INDEX = "tabindex";
var $871ea46ce85d65bc$var$DISABLED = "disabled";
var $871ea46ce85d65bc$var$ARIA_PREFIX = "aria-";
var $871ea46ce85d65bc$var$ARIA_CONTROLS = $871ea46ce85d65bc$var$ARIA_PREFIX + "controls";
var $871ea46ce85d65bc$var$ARIA_CURRENT = $871ea46ce85d65bc$var$ARIA_PREFIX + "current";
var $871ea46ce85d65bc$var$ARIA_SELECTED = $871ea46ce85d65bc$var$ARIA_PREFIX + "selected";
var $871ea46ce85d65bc$var$ARIA_LABEL = $871ea46ce85d65bc$var$ARIA_PREFIX + "label";
var $871ea46ce85d65bc$var$ARIA_LABELLEDBY = $871ea46ce85d65bc$var$ARIA_PREFIX + "labelledby";
var $871ea46ce85d65bc$var$ARIA_HIDDEN = $871ea46ce85d65bc$var$ARIA_PREFIX + "hidden";
var $871ea46ce85d65bc$var$ARIA_ORIENTATION = $871ea46ce85d65bc$var$ARIA_PREFIX + "orientation";
var $871ea46ce85d65bc$var$ARIA_ROLEDESCRIPTION = $871ea46ce85d65bc$var$ARIA_PREFIX + "roledescription";
var $871ea46ce85d65bc$var$ARIA_LIVE = $871ea46ce85d65bc$var$ARIA_PREFIX + "live";
var $871ea46ce85d65bc$var$ARIA_BUSY = $871ea46ce85d65bc$var$ARIA_PREFIX + "busy";
var $871ea46ce85d65bc$var$ARIA_ATOMIC = $871ea46ce85d65bc$var$ARIA_PREFIX + "atomic";
var $871ea46ce85d65bc$var$ALL_ATTRIBUTES = [
    $871ea46ce85d65bc$var$ROLE,
    $871ea46ce85d65bc$var$TAB_INDEX,
    $871ea46ce85d65bc$var$DISABLED,
    $871ea46ce85d65bc$var$ARIA_CONTROLS,
    $871ea46ce85d65bc$var$ARIA_CURRENT,
    $871ea46ce85d65bc$var$ARIA_LABEL,
    $871ea46ce85d65bc$var$ARIA_LABELLEDBY,
    $871ea46ce85d65bc$var$ARIA_HIDDEN,
    $871ea46ce85d65bc$var$ARIA_ORIENTATION,
    $871ea46ce85d65bc$var$ARIA_ROLEDESCRIPTION
];
var $871ea46ce85d65bc$var$CLASS_PREFIX = $871ea46ce85d65bc$var$PROJECT_CODE + "__";
var $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX = "is-";
var $871ea46ce85d65bc$export$93b21159ad85c843 = $871ea46ce85d65bc$var$PROJECT_CODE;
var $871ea46ce85d65bc$export$7738b09ac0a98952 = $871ea46ce85d65bc$var$CLASS_PREFIX + "track";
var $871ea46ce85d65bc$export$19cc2a5451235cae = $871ea46ce85d65bc$var$CLASS_PREFIX + "list";
var $871ea46ce85d65bc$export$8d922915837a38d3 = $871ea46ce85d65bc$var$CLASS_PREFIX + "slide";
var $871ea46ce85d65bc$export$2c1ba4a4f1aa4947 = $871ea46ce85d65bc$export$8d922915837a38d3 + "--clone";
var $871ea46ce85d65bc$export$e9ba7e444ba60a12 = $871ea46ce85d65bc$export$8d922915837a38d3 + "__container";
var $871ea46ce85d65bc$export$a26cbd955fecf11e = $871ea46ce85d65bc$var$CLASS_PREFIX + "arrows";
var $871ea46ce85d65bc$export$516e7d18e13a2dca = $871ea46ce85d65bc$var$CLASS_PREFIX + "arrow";
var $871ea46ce85d65bc$export$58ea3db24c33b76 = $871ea46ce85d65bc$export$516e7d18e13a2dca + "--prev";
var $871ea46ce85d65bc$export$4885afd7098a65c2 = $871ea46ce85d65bc$export$516e7d18e13a2dca + "--next";
var $871ea46ce85d65bc$export$cbf8e5a0ab95eda3 = $871ea46ce85d65bc$var$CLASS_PREFIX + "pagination";
var $871ea46ce85d65bc$export$52f2cca6a5eee805 = $871ea46ce85d65bc$export$cbf8e5a0ab95eda3 + "__page";
var $871ea46ce85d65bc$export$4c82dc32b1c4ace5 = $871ea46ce85d65bc$var$CLASS_PREFIX + "progress";
var $871ea46ce85d65bc$export$2c9b091c749f4409 = $871ea46ce85d65bc$export$4c82dc32b1c4ace5 + "__bar";
var $871ea46ce85d65bc$export$a29701deef84b825 = $871ea46ce85d65bc$var$CLASS_PREFIX + "toggle";
var $871ea46ce85d65bc$export$d9d247d51b430dbb = $871ea46ce85d65bc$export$a29701deef84b825 + "__play";
var $871ea46ce85d65bc$export$3529f201a419925b = $871ea46ce85d65bc$export$a29701deef84b825 + "__pause";
var $871ea46ce85d65bc$export$3e5381ee3fab8374 = $871ea46ce85d65bc$var$CLASS_PREFIX + "spinner";
var $871ea46ce85d65bc$export$bb78d7c200da8960 = $871ea46ce85d65bc$var$CLASS_PREFIX + "sr";
var $871ea46ce85d65bc$export$7761661e2d5b9388 = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "initialized";
var $871ea46ce85d65bc$export$72d36ecf3758cb4b = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "active";
var $871ea46ce85d65bc$export$e423ac4972f5e196 = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "prev";
var $871ea46ce85d65bc$export$457a2d20827a2779 = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "next";
var $871ea46ce85d65bc$export$53ca4621bbab9a = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "visible";
var $871ea46ce85d65bc$export$d22ec4ccb7996ba2 = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "loading";
var $871ea46ce85d65bc$export$b6f202a162a09100 = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "focus-in";
var $871ea46ce85d65bc$export$cd908cd1dd625e29 = $871ea46ce85d65bc$var$STATUS_CLASS_PREFIX + "overflow";
var $871ea46ce85d65bc$export$49f9eaea10ebf193 = [
    $871ea46ce85d65bc$export$72d36ecf3758cb4b,
    $871ea46ce85d65bc$export$53ca4621bbab9a,
    $871ea46ce85d65bc$export$e423ac4972f5e196,
    $871ea46ce85d65bc$export$457a2d20827a2779,
    $871ea46ce85d65bc$export$d22ec4ccb7996ba2,
    $871ea46ce85d65bc$export$b6f202a162a09100,
    $871ea46ce85d65bc$export$cd908cd1dd625e29
];
var $871ea46ce85d65bc$export$ba41d43e4a419565 = {
    slide: $871ea46ce85d65bc$export$8d922915837a38d3,
    clone: $871ea46ce85d65bc$export$2c1ba4a4f1aa4947,
    arrows: $871ea46ce85d65bc$export$a26cbd955fecf11e,
    arrow: $871ea46ce85d65bc$export$516e7d18e13a2dca,
    prev: $871ea46ce85d65bc$export$58ea3db24c33b76,
    next: $871ea46ce85d65bc$export$4885afd7098a65c2,
    pagination: $871ea46ce85d65bc$export$cbf8e5a0ab95eda3,
    page: $871ea46ce85d65bc$export$52f2cca6a5eee805,
    spinner: $871ea46ce85d65bc$export$3e5381ee3fab8374
};
function $871ea46ce85d65bc$var$closest(from, selector) {
    if ($871ea46ce85d65bc$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($871ea46ce85d65bc$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $871ea46ce85d65bc$var$FRICTION = 5;
var $871ea46ce85d65bc$var$LOG_INTERVAL = 200;
var $871ea46ce85d65bc$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $871ea46ce85d65bc$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $871ea46ce85d65bc$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $871ea46ce85d65bc$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($871ea46ce85d65bc$export$7f4701ac5e05e39f, destroy);
        on($871ea46ce85d65bc$export$7f4701ac5e05e39f, setup);
        on($871ea46ce85d65bc$export$db40ab7c0855fa5c, update);
        bind(document, $871ea46ce85d65bc$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $871ea46ce85d65bc$var$toggleClass(root, $871ea46ce85d65bc$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $871ea46ce85d65bc$var$ALL_ATTRIBUTES.concat("style");
        $871ea46ce85d65bc$var$empty(slides);
        $871ea46ce85d65bc$var$removeClass(root, rootClasses);
        $871ea46ce85d65bc$var$removeClass(track, trackClasses);
        $871ea46ce85d65bc$var$removeAttribute([
            track,
            list
        ], attrs);
        $871ea46ce85d65bc$var$removeAttribute(root, completely ? attrs : [
            "style",
            $871ea46ce85d65bc$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $871ea46ce85d65bc$var$removeClass(root, rootClasses);
        $871ea46ce85d65bc$var$removeClass(track, trackClasses);
        rootClasses = getClasses($871ea46ce85d65bc$export$93b21159ad85c843);
        trackClasses = getClasses($871ea46ce85d65bc$export$7738b09ac0a98952);
        $871ea46ce85d65bc$var$addClass(root, rootClasses);
        $871ea46ce85d65bc$var$addClass(track, trackClasses);
        $871ea46ce85d65bc$var$setAttribute(root, $871ea46ce85d65bc$var$ARIA_LABEL, options.label);
        $871ea46ce85d65bc$var$setAttribute(root, $871ea46ce85d65bc$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $871ea46ce85d65bc$export$7738b09ac0a98952);
        list = $871ea46ce85d65bc$var$child(track, "." + $871ea46ce85d65bc$export$19cc2a5451235cae);
        $871ea46ce85d65bc$var$assert(track && list, "A track/list element is missing.");
        $871ea46ce85d65bc$var$push(slides, $871ea46ce85d65bc$var$children(list, "." + $871ea46ce85d65bc$export$8d922915837a38d3 + ":not(." + $871ea46ce85d65bc$export$2c1ba4a4f1aa4947 + ")"));
        $871ea46ce85d65bc$var$forOwn({
            arrows: $871ea46ce85d65bc$export$a26cbd955fecf11e,
            pagination: $871ea46ce85d65bc$export$cbf8e5a0ab95eda3,
            prev: $871ea46ce85d65bc$export$58ea3db24c33b76,
            next: $871ea46ce85d65bc$export$4885afd7098a65c2,
            bar: $871ea46ce85d65bc$export$2c9b091c749f4409,
            toggle: $871ea46ce85d65bc$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $871ea46ce85d65bc$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $871ea46ce85d65bc$var$uniqueId($871ea46ce85d65bc$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$871ea46ce85d65bc$var$getAttribute(root, $871ea46ce85d65bc$var$ROLE) && root.tagName !== "SECTION" && role) $871ea46ce85d65bc$var$setAttribute(root, $871ea46ce85d65bc$var$ROLE, role);
        $871ea46ce85d65bc$var$setAttribute(root, $871ea46ce85d65bc$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $871ea46ce85d65bc$var$setAttribute(list, $871ea46ce85d65bc$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $871ea46ce85d65bc$var$query(root, selector);
        return elm && $871ea46ce85d65bc$var$closest(elm, "." + $871ea46ce85d65bc$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $871ea46ce85d65bc$export$93b21159ad85c843 && $871ea46ce85d65bc$export$72d36ecf3758cb4b
        ];
    }
    return $871ea46ce85d65bc$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $871ea46ce85d65bc$export$e5a58a5ee5b54c22 = "slide";
var $871ea46ce85d65bc$export$f42383286ed1223d = "loop";
var $871ea46ce85d65bc$export$742b62a5690c060 = "fade";
function $871ea46ce85d65bc$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $871ea46ce85d65bc$var$getAttribute(slide, "style");
    var label = $871ea46ce85d65bc$var$getAttribute(slide, $871ea46ce85d65bc$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $871ea46ce85d65bc$var$child(slide, "." + $871ea46ce85d65bc$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $871ea46ce85d65bc$var$pad(index + 1);
            $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ROLE, pagination ? "tabpanel" : "group");
            $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ARIA_LABEL, label || $871ea46ce85d65bc$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $871ea46ce85d65bc$var$apply(emit, $871ea46ce85d65bc$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $871ea46ce85d65bc$var$apply(emit, $871ea46ce85d65bc$export$6d5af59619d10e6a, self));
        on([
            $871ea46ce85d65bc$export$fe5802204b967f0d,
            $871ea46ce85d65bc$export$f0af896383d5adff,
            $871ea46ce85d65bc$export$ff8164bff3202b9
        ], update);
        on($871ea46ce85d65bc$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($871ea46ce85d65bc$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $871ea46ce85d65bc$var$removeClass(slide, $871ea46ce85d65bc$export$49f9eaea10ebf193);
        $871ea46ce85d65bc$var$removeAttribute(slide, $871ea46ce85d65bc$var$ALL_ATTRIBUTES);
        $871ea46ce85d65bc$var$setAttribute(slide, "style", styles);
        $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ARIA_LABEL, $871ea46ce85d65bc$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ARIA_CONTROLS, controls);
        $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $871ea46ce85d65bc$var$removeAttribute(slide, $871ea46ce85d65bc$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $871ea46ce85d65bc$var$toggleClass(slide, $871ea46ce85d65bc$export$e423ac4972f5e196, index === curr - 1);
            $871ea46ce85d65bc$var$toggleClass(slide, $871ea46ce85d65bc$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $871ea46ce85d65bc$var$hasClass(slide, $871ea46ce85d65bc$export$72d36ecf3758cb4b)) {
            $871ea46ce85d65bc$var$toggleClass(slide, $871ea46ce85d65bc$export$72d36ecf3758cb4b, active);
            $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $871ea46ce85d65bc$export$92e3eae133acac4c : $871ea46ce85d65bc$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $871ea46ce85d65bc$var$MOVING,
            $871ea46ce85d65bc$var$SCROLLING
        ])) $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$ARIA_HIDDEN, hidden || "");
        $871ea46ce85d65bc$var$setAttribute($871ea46ce85d65bc$var$queryAll(slide, options.focusableNodes || ""), $871ea46ce85d65bc$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $871ea46ce85d65bc$var$setAttribute(slide, $871ea46ce85d65bc$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $871ea46ce85d65bc$var$hasClass(slide, $871ea46ce85d65bc$export$53ca4621bbab9a)) {
            $871ea46ce85d65bc$var$toggleClass(slide, $871ea46ce85d65bc$export$53ca4621bbab9a, visible);
            emit(visible ? $871ea46ce85d65bc$export$6a5b3445e4066a53 : $871ea46ce85d65bc$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $871ea46ce85d65bc$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $871ea46ce85d65bc$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($871ea46ce85d65bc$export$742b62a5690c060)) return isActive();
        var trackRect = $871ea46ce85d65bc$var$rect(Components.Elements.track);
        var slideRect = $871ea46ce85d65bc$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $871ea46ce85d65bc$var$floor(trackRect[left]) <= $871ea46ce85d65bc$var$ceil(slideRect[left]) && $871ea46ce85d65bc$var$floor(slideRect[right]) <= $871ea46ce85d65bc$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $871ea46ce85d65bc$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($871ea46ce85d65bc$export$f42383286ed1223d))) diff = $871ea46ce85d65bc$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $871ea46ce85d65bc$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($871ea46ce85d65bc$export$7f4701ac5e05e39f, destroy);
        on($871ea46ce85d65bc$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $871ea46ce85d65bc$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $871ea46ce85d65bc$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $871ea46ce85d65bc$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $871ea46ce85d65bc$var$forEach(items, function(slide) {
            if ($871ea46ce85d65bc$var$isString(slide)) slide = $871ea46ce85d65bc$var$parseHtml(slide);
            if ($871ea46ce85d65bc$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $871ea46ce85d65bc$var$before(slide, ref) : $871ea46ce85d65bc$var$append(list, slide);
                $871ea46ce85d65bc$var$addClass(slide, options.classes.slide);
                observeImages(slide, $871ea46ce85d65bc$var$apply(emit, $871ea46ce85d65bc$export$7e019dae5103a285));
            }
        });
        emit($871ea46ce85d65bc$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $871ea46ce85d65bc$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($871ea46ce85d65bc$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($871ea46ce85d65bc$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $871ea46ce85d65bc$var$isString(matcher) ? $871ea46ce85d65bc$var$matches(Slide2.slide, matcher) : $871ea46ce85d65bc$var$includes($871ea46ce85d65bc$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $871ea46ce85d65bc$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $871ea46ce85d65bc$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $871ea46ce85d65bc$export$efff0f5979573c99($871ea46ce85d65bc$var$apply(emit, $871ea46ce85d65bc$export$7e019dae5103a285)));
        on([
            $871ea46ce85d65bc$export$db40ab7c0855fa5c,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f
        ], init);
        on($871ea46ce85d65bc$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $871ea46ce85d65bc$export$97170d9824b89709;
        $871ea46ce85d65bc$var$style(root, "maxWidth", $871ea46ce85d65bc$var$unit(options.width));
        $871ea46ce85d65bc$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $871ea46ce85d65bc$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $871ea46ce85d65bc$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $871ea46ce85d65bc$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $871ea46ce85d65bc$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($871ea46ce85d65bc$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $871ea46ce85d65bc$var$toggleClass(root, $871ea46ce85d65bc$export$cd908cd1dd625e29, overflow);
                emit($871ea46ce85d65bc$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $871ea46ce85d65bc$var$unit(padding[prop] || ($871ea46ce85d65bc$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $871ea46ce85d65bc$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $871ea46ce85d65bc$var$unit(options.height || $871ea46ce85d65bc$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $871ea46ce85d65bc$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $871ea46ce85d65bc$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $871ea46ce85d65bc$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $871ea46ce85d65bc$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $871ea46ce85d65bc$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $871ea46ce85d65bc$var$rect(Slide.slide)[resolve("right")];
            var left = $871ea46ce85d65bc$var$rect(list)[resolve("left")];
            return $871ea46ce85d65bc$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($871ea46ce85d65bc$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($871ea46ce85d65bc$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($871ea46ce85d65bc$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $871ea46ce85d65bc$var$MULTIPLIER = 2;
function $871ea46ce85d65bc$var$Clones(Splide2, Components2, options) {
    var event = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($871ea46ce85d65bc$export$7f4701ac5e05e39f, remount);
        on([
            $871ea46ce85d65bc$export$db40ab7c0855fa5c,
            $871ea46ce85d65bc$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $871ea46ce85d65bc$var$remove(clones);
        $871ea46ce85d65bc$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($871ea46ce85d65bc$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$871ea46ce85d65bc$var$push(slides, slides);
            $871ea46ce85d65bc$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $871ea46ce85d65bc$var$before(clone, slides[0].slide) : $871ea46ce85d65bc$var$append(Elements.list, clone);
                $871ea46ce85d65bc$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $871ea46ce85d65bc$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $871ea46ce85d65bc$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($871ea46ce85d65bc$export$f42383286ed1223d)) clones2 = 0;
        else if ($871ea46ce85d65bc$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $871ea46ce85d65bc$var$ceil($871ea46ce85d65bc$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $871ea46ce85d65bc$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $871ea46ce85d65bc$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $871ea46ce85d65bc$export$d300dc1a2634364b,
            $871ea46ce85d65bc$export$d637eba1e9e28482,
            $871ea46ce85d65bc$export$db40ab7c0855fa5c,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($871ea46ce85d65bc$var$MOVING);
        emit($871ea46ce85d65bc$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($871ea46ce85d65bc$var$IDLE);
            emit($871ea46ce85d65bc$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($871ea46ce85d65bc$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $871ea46ce85d65bc$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($871ea46ce85d65bc$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($871ea46ce85d65bc$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($871ea46ce85d65bc$var$ceil($871ea46ce85d65bc$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $871ea46ce85d65bc$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $871ea46ce85d65bc$var$rect(list)[left] - $871ea46ce85d65bc$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($871ea46ce85d65bc$export$e5a58a5ee5b54c22)) position = $871ea46ce85d65bc$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $871ea46ce85d65bc$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $871ea46ce85d65bc$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $871ea46ce85d65bc$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($871ea46ce85d65bc$export$f42383286ed1223d);
    var isSlide = Splide2.is($871ea46ce85d65bc$export$e5a58a5ee5b54c22);
    var getNext = $871ea46ce85d65bc$var$apply(getAdjacent, false);
    var getPrev = $871ea46ce85d65bc$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $871ea46ce85d65bc$export$db40ab7c0855fa5c,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f,
            $871ea46ce85d65bc$export$28dea85f216954dc
        ], init);
        on($871ea46ce85d65bc$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $871ea46ce85d65bc$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($871ea46ce85d65bc$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $871ea46ce85d65bc$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($871ea46ce85d65bc$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $871ea46ce85d65bc$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$871ea46ce85d65bc$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($871ea46ce85d65bc$var$between(0, dest, from, true) || $871ea46ce85d65bc$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $871ea46ce85d65bc$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $871ea46ce85d65bc$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $871ea46ce85d65bc$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $871ea46ce85d65bc$var$min(index, endIndex) : $871ea46ce85d65bc$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $871ea46ce85d65bc$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$871ea46ce85d65bc$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $871ea46ce85d65bc$var$MOVING,
            $871ea46ce85d65bc$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $871ea46ce85d65bc$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $871ea46ce85d65bc$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $871ea46ce85d65bc$var$SIZE = 40;
function $871ea46ce85d65bc$var$Arrows(Splide2, Components2, options) {
    var event = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($871ea46ce85d65bc$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $871ea46ce85d65bc$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $871ea46ce85d65bc$var$display(wrapper, enabled ? "" : "none");
            $871ea46ce85d65bc$var$addClass(wrapper, wrapperClasses = $871ea46ce85d65bc$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $871ea46ce85d65bc$var$setAttribute([
                    prev,
                    next
                ], $871ea46ce85d65bc$var$ARIA_CONTROLS, track.id);
                emit($871ea46ce85d65bc$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $871ea46ce85d65bc$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $871ea46ce85d65bc$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $871ea46ce85d65bc$var$removeAttribute([
            prev,
            next
        ], $871ea46ce85d65bc$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $871ea46ce85d65bc$export$d300dc1a2634364b,
            $871ea46ce85d65bc$export$fe5802204b967f0d,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f,
            $871ea46ce85d65bc$export$ff8164bff3202b9,
            $871ea46ce85d65bc$export$28dea85f216954dc
        ], update);
        bind(next, "click", $871ea46ce85d65bc$var$apply(go, ">"));
        bind(prev, "click", $871ea46ce85d65bc$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $871ea46ce85d65bc$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $871ea46ce85d65bc$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $871ea46ce85d65bc$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $871ea46ce85d65bc$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $871ea46ce85d65bc$var$SIZE + " " + $871ea46ce85d65bc$var$SIZE + '" width="' + $871ea46ce85d65bc$var$SIZE + '" height="' + $871ea46ce85d65bc$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $871ea46ce85d65bc$var$PATH) + '" />';
        return $871ea46ce85d65bc$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $871ea46ce85d65bc$var$setAttribute(prev, $871ea46ce85d65bc$var$ARIA_LABEL, prevLabel);
            $871ea46ce85d65bc$var$setAttribute(next, $871ea46ce85d65bc$var$ARIA_LABEL, nextLabel);
            emit($871ea46ce85d65bc$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $871ea46ce85d65bc$var$INTERVAL_DATA_ATTRIBUTE = $871ea46ce85d65bc$var$DATA_ATTRIBUTE + "-interval";
function $871ea46ce85d65bc$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $871ea46ce85d65bc$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $871ea46ce85d65bc$var$setAttribute(toggle, $871ea46ce85d65bc$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $871ea46ce85d65bc$export$2aa493d7c3275167,
            $871ea46ce85d65bc$export$49801896908b5e33,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($871ea46ce85d65bc$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($871ea46ce85d65bc$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($871ea46ce85d65bc$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $871ea46ce85d65bc$var$toggleClass(toggle, $871ea46ce85d65bc$export$72d36ecf3758cb4b, !stopped);
            $871ea46ce85d65bc$var$setAttribute(toggle, $871ea46ce85d65bc$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $871ea46ce85d65bc$var$style(bar, "width", rate * 100 + "%");
        emit($871ea46ce85d65bc$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$871ea46ce85d65bc$var$getAttribute(Slide.slide, $871ea46ce85d65bc$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $871ea46ce85d65bc$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($871ea46ce85d65bc$export$9f64346e17f0ec8e, $871ea46ce85d65bc$var$apply(toggle, true));
            on([
                $871ea46ce85d65bc$export$d300dc1a2634364b,
                $871ea46ce85d65bc$export$db40ab7c0855fa5c,
                $871ea46ce85d65bc$export$7f4701ac5e05e39f
            ], $871ea46ce85d65bc$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $871ea46ce85d65bc$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $871ea46ce85d65bc$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $871ea46ce85d65bc$var$apply(cover, false)
    };
}
var $871ea46ce85d65bc$var$BOUNCE_DIFF_THRESHOLD = 10;
var $871ea46ce85d65bc$var$BOUNCE_DURATION = 600;
var $871ea46ce85d65bc$var$FRICTION_FACTOR = 0.6;
var $871ea46ce85d65bc$var$BASE_VELOCITY = 1.5;
var $871ea46ce85d65bc$var$MIN_DURATION = 800;
function $871ea46ce85d65bc$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($871ea46ce85d65bc$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($871ea46ce85d65bc$export$2aa493d7c3275167, clear);
        on([
            $871ea46ce85d65bc$export$db40ab7c0855fa5c,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $871ea46ce85d65bc$var$sign(destination) * size * $871ea46ce85d65bc$var$floor($871ea46ce85d65bc$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $871ea46ce85d65bc$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $871ea46ce85d65bc$var$max($871ea46ce85d65bc$var$abs(destination - from) / $871ea46ce85d65bc$var$BASE_VELOCITY, $871ea46ce85d65bc$var$MIN_DURATION);
        callback = onScrolled;
        interval = $871ea46ce85d65bc$export$46ad21b25b6dccf0(duration, onEnd, $871ea46ce85d65bc$var$apply(update, from, destination, noConstrain), 1);
        set($871ea46ce85d65bc$var$SCROLLING);
        emit($871ea46ce85d65bc$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($871ea46ce85d65bc$var$IDLE);
        callback && callback();
        emit($871ea46ce85d65bc$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $871ea46ce85d65bc$var$FRICTION_FACTOR;
            if ($871ea46ce85d65bc$var$abs(diff) < $871ea46ce85d65bc$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $871ea46ce85d65bc$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $871ea46ce85d65bc$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $871ea46ce85d65bc$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $871ea46ce85d65bc$var$POINTER_MOVE_EVENTS, $871ea46ce85d65bc$var$noop, $871ea46ce85d65bc$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $871ea46ce85d65bc$var$POINTER_UP_EVENTS, $871ea46ce85d65bc$var$noop, $871ea46ce85d65bc$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $871ea46ce85d65bc$var$POINTER_DOWN_EVENTS, onPointerDown, $871ea46ce85d65bc$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $871ea46ce85d65bc$var$prevent);
        on([
            $871ea46ce85d65bc$export$d300dc1a2634364b,
            $871ea46ce85d65bc$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $871ea46ce85d65bc$var$MOVING,
                        $871ea46ce85d65bc$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $871ea46ce85d65bc$var$POINTER_MOVE_EVENTS, onPointerMove, $871ea46ce85d65bc$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $871ea46ce85d65bc$var$POINTER_UP_EVENTS, onPointerUp, $871ea46ce85d65bc$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $871ea46ce85d65bc$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($871ea46ce85d65bc$var$DRAGGING)) {
            state.set($871ea46ce85d65bc$var$DRAGGING);
            emit($871ea46ce85d65bc$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $871ea46ce85d65bc$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($871ea46ce85d65bc$export$8e9f636d2c722196);
                $871ea46ce85d65bc$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $871ea46ce85d65bc$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($871ea46ce85d65bc$var$DRAGGING)) {
            state.set($871ea46ce85d65bc$var$IDLE);
            emit($871ea46ce85d65bc$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $871ea46ce85d65bc$var$prevent(e);
        }
        unbind(target, $871ea46ce85d65bc$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $871ea46ce85d65bc$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $871ea46ce85d65bc$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($871ea46ce85d65bc$export$742b62a5690c060)) Controller.go(orient($871ea46ce85d65bc$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($871ea46ce85d65bc$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $871ea46ce85d65bc$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $871ea46ce85d65bc$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $871ea46ce85d65bc$var$abs(diffCoord(e)) > $871ea46ce85d65bc$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($871ea46ce85d65bc$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $871ea46ce85d65bc$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $871ea46ce85d65bc$var$sign(velocity) * $871ea46ce85d65bc$var$min($871ea46ce85d65bc$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $871ea46ce85d65bc$var$timeOf(e) - $871ea46ce85d65bc$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($871ea46ce85d65bc$export$e5a58a5ee5b54c22) ? $871ea46ce85d65bc$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$871ea46ce85d65bc$var$matches(target2, "." + $871ea46ce85d65bc$export$52f2cca6a5eee805 + ", ." + $871ea46ce85d65bc$export$516e7d18e13a2dca) && (!noDrag || !$871ea46ce85d65bc$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $871ea46ce85d65bc$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $871ea46ce85d65bc$var$ARROW_RIGHT,
    Left: $871ea46ce85d65bc$var$ARROW_LEFT,
    Up: $871ea46ce85d65bc$var$ARROW_UP,
    Down: $871ea46ce85d65bc$var$ARROW_DOWN
};
function $871ea46ce85d65bc$var$normalizeKey(key) {
    key = $871ea46ce85d65bc$var$isString(key) ? key : key.key;
    return $871ea46ce85d65bc$var$NORMALIZATION_MAP[key] || key;
}
var $871ea46ce85d65bc$var$KEYBOARD_EVENT = "keydown";
function $871ea46ce85d65bc$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($871ea46ce85d65bc$export$db40ab7c0855fa5c, destroy);
        on($871ea46ce85d65bc$export$db40ab7c0855fa5c, init);
        on($871ea46ce85d65bc$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $871ea46ce85d65bc$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $871ea46ce85d65bc$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $871ea46ce85d65bc$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $871ea46ce85d65bc$var$normalizeKey(e);
            if (key === resolve($871ea46ce85d65bc$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($871ea46ce85d65bc$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $871ea46ce85d65bc$var$SRC_DATA_ATTRIBUTE = $871ea46ce85d65bc$var$DATA_ATTRIBUTE + "-lazy";
var $871ea46ce85d65bc$var$SRCSET_DATA_ATTRIBUTE = $871ea46ce85d65bc$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $871ea46ce85d65bc$var$IMAGE_SELECTOR = "[" + $871ea46ce85d65bc$var$SRC_DATA_ATTRIBUTE + "], [" + $871ea46ce85d65bc$var$SRCSET_DATA_ATTRIBUTE + "]";
function $871ea46ce85d65bc$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $871ea46ce85d65bc$export$fe5802204b967f0d,
        $871ea46ce85d65bc$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($871ea46ce85d65bc$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $871ea46ce85d65bc$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $871ea46ce85d65bc$var$queryAll(Slide.slide, $871ea46ce85d65bc$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $871ea46ce85d65bc$var$getAttribute(img, $871ea46ce85d65bc$var$SRC_DATA_ATTRIBUTE);
                var srcset = $871ea46ce85d65bc$var$getAttribute(img, $871ea46ce85d65bc$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $871ea46ce85d65bc$var$child(parent, "." + className) || $871ea46ce85d65bc$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $871ea46ce85d65bc$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $871ea46ce85d65bc$var$addClass(data[1].slide, $871ea46ce85d65bc$export$d22ec4ccb7996ba2);
        bind(img, "load error", $871ea46ce85d65bc$var$apply(onLoad, data));
        $871ea46ce85d65bc$var$setAttribute(img, "src", $871ea46ce85d65bc$var$getAttribute(img, $871ea46ce85d65bc$var$SRC_DATA_ATTRIBUTE));
        $871ea46ce85d65bc$var$setAttribute(img, "srcset", $871ea46ce85d65bc$var$getAttribute(img, $871ea46ce85d65bc$var$SRCSET_DATA_ATTRIBUTE));
        $871ea46ce85d65bc$var$removeAttribute(img, $871ea46ce85d65bc$var$SRC_DATA_ATTRIBUTE);
        $871ea46ce85d65bc$var$removeAttribute(img, $871ea46ce85d65bc$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $871ea46ce85d65bc$var$removeClass(Slide.slide, $871ea46ce85d65bc$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $871ea46ce85d65bc$var$remove(data[2]);
            $871ea46ce85d65bc$var$display(img, "");
            emit($871ea46ce85d65bc$export$9f64346e17f0ec8e, img, Slide);
            emit($871ea46ce85d65bc$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $871ea46ce85d65bc$var$apply($871ea46ce85d65bc$var$empty, entries),
        check: check
    };
}
function $871ea46ce85d65bc$var$Pagination(Splide2, Components2, options) {
    var event = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $871ea46ce85d65bc$export$db40ab7c0855fa5c,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f,
            $871ea46ce85d65bc$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $871ea46ce85d65bc$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $871ea46ce85d65bc$export$2aa493d7c3275167,
                $871ea46ce85d65bc$export$49801896908b5e33,
                $871ea46ce85d65bc$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($871ea46ce85d65bc$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $871ea46ce85d65bc$var$remove(placeholder ? $871ea46ce85d65bc$var$slice(list.children) : list);
            $871ea46ce85d65bc$var$removeClass(list, paginationClasses);
            $871ea46ce85d65bc$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $871ea46ce85d65bc$var$ceil(length / perPage);
        list = placeholder || $871ea46ce85d65bc$var$create("ul", classes.pagination, Elements.track.parentElement);
        $871ea46ce85d65bc$var$addClass(list, paginationClasses = $871ea46ce85d65bc$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $871ea46ce85d65bc$var$setAttribute(list, $871ea46ce85d65bc$var$ROLE, "tablist");
        $871ea46ce85d65bc$var$setAttribute(list, $871ea46ce85d65bc$var$ARIA_LABEL, i18n.select);
        $871ea46ce85d65bc$var$setAttribute(list, $871ea46ce85d65bc$var$ARIA_ORIENTATION, getDirection() === $871ea46ce85d65bc$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $871ea46ce85d65bc$var$create("li", null, list);
            var button = $871ea46ce85d65bc$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $871ea46ce85d65bc$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $871ea46ce85d65bc$var$apply(onKeydown, i));
            $871ea46ce85d65bc$var$setAttribute(li, $871ea46ce85d65bc$var$ROLE, "presentation");
            $871ea46ce85d65bc$var$setAttribute(button, $871ea46ce85d65bc$var$ROLE, "tab");
            $871ea46ce85d65bc$var$setAttribute(button, $871ea46ce85d65bc$var$ARIA_CONTROLS, controls.join(" "));
            $871ea46ce85d65bc$var$setAttribute(button, $871ea46ce85d65bc$var$ARIA_LABEL, $871ea46ce85d65bc$var$format(text, i + 1));
            $871ea46ce85d65bc$var$setAttribute(button, $871ea46ce85d65bc$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $871ea46ce85d65bc$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($871ea46ce85d65bc$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($871ea46ce85d65bc$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $871ea46ce85d65bc$var$focus(item.button);
            go(">" + nextPage);
            $871ea46ce85d65bc$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $871ea46ce85d65bc$var$removeClass(button, $871ea46ce85d65bc$export$72d36ecf3758cb4b);
            $871ea46ce85d65bc$var$removeAttribute(button, $871ea46ce85d65bc$var$ARIA_SELECTED);
            $871ea46ce85d65bc$var$setAttribute(button, $871ea46ce85d65bc$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $871ea46ce85d65bc$var$addClass(_button, $871ea46ce85d65bc$export$72d36ecf3758cb4b);
            $871ea46ce85d65bc$var$setAttribute(_button, $871ea46ce85d65bc$var$ARIA_SELECTED, true);
            $871ea46ce85d65bc$var$setAttribute(_button, $871ea46ce85d65bc$var$TAB_INDEX, "");
        }
        emit($871ea46ce85d65bc$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $871ea46ce85d65bc$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $871ea46ce85d65bc$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $871ea46ce85d65bc$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $871ea46ce85d65bc$export$f188226459c8a3ff(splide);
        event.on($871ea46ce85d65bc$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($871ea46ce85d65bc$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($871ea46ce85d65bc$export$5adb665701eda1ce, onClick);
        on($871ea46ce85d65bc$export$6d5af59619d10e6a, onKeydown);
        on([
            $871ea46ce85d65bc$export$d300dc1a2634364b,
            $871ea46ce85d65bc$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($871ea46ce85d65bc$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $871ea46ce85d65bc$var$setAttribute(Components2.Elements.list, $871ea46ce85d65bc$var$ARIA_ORIENTATION, options.direction === $871ea46ce85d65bc$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($871ea46ce85d65bc$var$includes($871ea46ce85d65bc$var$TRIGGER_KEYS, $871ea46ce85d65bc$var$normalizeKey(e))) {
            onClick(Slide);
            $871ea46ce85d65bc$var$prevent(e);
        }
    }
    return {
        setup: $871ea46ce85d65bc$var$apply(Components2.Media.set, {
            slideFocus: $871ea46ce85d65bc$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $871ea46ce85d65bc$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $871ea46ce85d65bc$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $871ea46ce85d65bc$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($871ea46ce85d65bc$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $871ea46ce85d65bc$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($871ea46ce85d65bc$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $871ea46ce85d65bc$var$SR_REMOVAL_DELAY = 90;
function $871ea46ce85d65bc$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $871ea46ce85d65bc$var$create("span", $871ea46ce85d65bc$export$bb78d7c200da8960);
    var interval = $871ea46ce85d65bc$export$46ad21b25b6dccf0($871ea46ce85d65bc$var$SR_REMOVAL_DELAY, $871ea46ce85d65bc$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $871ea46ce85d65bc$var$setAttribute(track, $871ea46ce85d65bc$var$ARIA_ATOMIC, true);
            sr.textContent = "…";
            on($871ea46ce85d65bc$export$23663268a31b79e2, $871ea46ce85d65bc$var$apply(disable, true));
            on($871ea46ce85d65bc$export$16a1e4f3d0368265, $871ea46ce85d65bc$var$apply(disable, false));
            on([
                $871ea46ce85d65bc$export$fe5802204b967f0d,
                $871ea46ce85d65bc$export$ff8164bff3202b9
            ], $871ea46ce85d65bc$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $871ea46ce85d65bc$var$setAttribute(track, $871ea46ce85d65bc$var$ARIA_BUSY, active);
        if (active) {
            $871ea46ce85d65bc$var$append(track, sr);
            interval.start();
        } else {
            $871ea46ce85d65bc$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $871ea46ce85d65bc$var$removeAttribute(track, [
            $871ea46ce85d65bc$var$ARIA_LIVE,
            $871ea46ce85d65bc$var$ARIA_ATOMIC,
            $871ea46ce85d65bc$var$ARIA_BUSY
        ]);
        $871ea46ce85d65bc$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $871ea46ce85d65bc$var$setAttribute(track, $871ea46ce85d65bc$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $871ea46ce85d65bc$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $871ea46ce85d65bc$var$Media,
    Direction: $871ea46ce85d65bc$var$Direction,
    Elements: $871ea46ce85d65bc$var$Elements,
    Slides: $871ea46ce85d65bc$var$Slides,
    Layout: $871ea46ce85d65bc$var$Layout,
    Clones: $871ea46ce85d65bc$var$Clones,
    Move: $871ea46ce85d65bc$var$Move,
    Controller: $871ea46ce85d65bc$var$Controller,
    Arrows: $871ea46ce85d65bc$var$Arrows,
    Autoplay: $871ea46ce85d65bc$var$Autoplay,
    Cover: $871ea46ce85d65bc$var$Cover,
    Scroll: $871ea46ce85d65bc$var$Scroll,
    Drag: $871ea46ce85d65bc$var$Drag,
    Keyboard: $871ea46ce85d65bc$var$Keyboard,
    LazyLoad: $871ea46ce85d65bc$var$LazyLoad,
    Pagination: $871ea46ce85d65bc$var$Pagination,
    Sync: $871ea46ce85d65bc$var$Sync,
    Wheel: $871ea46ce85d65bc$var$Wheel,
    Live: $871ea46ce85d65bc$var$Live
});
var $871ea46ce85d65bc$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $871ea46ce85d65bc$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $871ea46ce85d65bc$export$ba41d43e4a419565,
    i18n: $871ea46ce85d65bc$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $871ea46ce85d65bc$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2).on([
            $871ea46ce85d65bc$export$d300dc1a2634364b,
            $871ea46ce85d65bc$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $871ea46ce85d65bc$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $871ea46ce85d65bc$var$noop
    };
}
function $871ea46ce85d65bc$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $871ea46ce85d65bc$var$apply($871ea46ce85d65bc$var$style, list, "transition");
    var endCallback;
    function mount() {
        $871ea46ce85d65bc$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($871ea46ce85d65bc$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($871ea46ce85d65bc$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $871ea46ce85d65bc$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $871ea46ce85d65bc$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $871ea46ce85d65bc$export$7254cc27399e90bd($871ea46ce85d65bc$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $871ea46ce85d65bc$var$isString(target) ? $871ea46ce85d65bc$var$query(document, target) : target;
        $871ea46ce85d65bc$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $871ea46ce85d65bc$var$merge({
            label: $871ea46ce85d65bc$var$getAttribute(root, $871ea46ce85d65bc$var$ARIA_LABEL) || "",
            labelledby: $871ea46ce85d65bc$var$getAttribute(root, $871ea46ce85d65bc$var$ARIA_LABELLEDBY) || ""
        }, $871ea46ce85d65bc$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $871ea46ce85d65bc$var$merge(options, JSON.parse($871ea46ce85d65bc$var$getAttribute(root, $871ea46ce85d65bc$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $871ea46ce85d65bc$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($871ea46ce85d65bc$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $871ea46ce85d65bc$var$assert(state.is([
            $871ea46ce85d65bc$var$CREATED,
            $871ea46ce85d65bc$var$DESTROYED
        ]), "Already mounted!");
        state.set($871ea46ce85d65bc$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($871ea46ce85d65bc$export$742b62a5690c060) ? $871ea46ce85d65bc$var$Fade : $871ea46ce85d65bc$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $871ea46ce85d65bc$var$assign({}, $871ea46ce85d65bc$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $871ea46ce85d65bc$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $871ea46ce85d65bc$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($871ea46ce85d65bc$export$d300dc1a2634364b);
        $871ea46ce85d65bc$var$addClass(this.root, $871ea46ce85d65bc$export$7761661e2d5b9388);
        state.set($871ea46ce85d65bc$var$IDLE);
        this.emit($871ea46ce85d65bc$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($871ea46ce85d65bc$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($871ea46ce85d65bc$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($871ea46ce85d65bc$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($871ea46ce85d65bc$var$CREATED)) $871ea46ce85d65bc$export$f188226459c8a3ff(this).on($871ea46ce85d65bc$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $871ea46ce85d65bc$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($871ea46ce85d65bc$export$88c4cf7419e470cd);
            event.destroy();
            completely && $871ea46ce85d65bc$var$empty(this.splides);
            state.set($871ea46ce85d65bc$var$DESTROYED);
        }
        return this;
    };
    $871ea46ce85d65bc$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $871ea46ce85d65bc$export$24494c7438c070bf = $871ea46ce85d65bc$var$_Splide;
$871ea46ce85d65bc$export$24494c7438c070bf.defaults = {};
$871ea46ce85d65bc$export$24494c7438c070bf.STATES = $871ea46ce85d65bc$var$STATES;
var $871ea46ce85d65bc$var$CLASS_RENDERED = "is-rendered";
var $871ea46ce85d65bc$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $871ea46ce85d65bc$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $871ea46ce85d65bc$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $871ea46ce85d65bc$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $871ea46ce85d65bc$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $871ea46ce85d65bc$var$merge($871ea46ce85d65bc$export$f484e977a69c6ba6, defaults || {});
        $871ea46ce85d65bc$var$merge($871ea46ce85d65bc$var$merge(this.options, $871ea46ce85d65bc$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $871ea46ce85d65bc$var$assign({}, $871ea46ce85d65bc$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $871ea46ce85d65bc$var$uniqueId("splide");
        this.Style = new $871ea46ce85d65bc$var$Style(this.id, this.options);
        this.Direction = $871ea46ce85d65bc$var$Direction(null, null, this.options);
        $871ea46ce85d65bc$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $871ea46ce85d65bc$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $871ea46ce85d65bc$var$queryAll(root, "." + $871ea46ce85d65bc$export$2c1ba4a4f1aa4947);
        on($871ea46ce85d65bc$export$d300dc1a2634364b, function() {
            $871ea46ce85d65bc$var$remove($871ea46ce85d65bc$var$child(root, "style"));
        });
        $871ea46ce85d65bc$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $871ea46ce85d65bc$var$push(this.slides, this.contents.map(function(content, index) {
            content = $871ea46ce85d65bc$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $871ea46ce85d65bc$export$72d36ecf3758cb4b : "");
            $871ea46ce85d65bc$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $871ea46ce85d65bc$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $871ea46ce85d65bc$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $871ea46ce85d65bc$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $871ea46ce85d65bc$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $871ea46ce85d65bc$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $871ea46ce85d65bc$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $871ea46ce85d65bc$var$unit(padding[prop] || ($871ea46ce85d65bc$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $871ea46ce85d65bc$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $871ea46ce85d65bc$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $871ea46ce85d65bc$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $871ea46ce85d65bc$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $871ea46ce85d65bc$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($871ea46ce85d65bc$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $871ea46ce85d65bc$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $871ea46ce85d65bc$var$merge($871ea46ce85d65bc$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $871ea46ce85d65bc$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $871ea46ce85d65bc$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $871ea46ce85d65bc$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $871ea46ce85d65bc$export$93b21159ad85c843,
            $871ea46ce85d65bc$export$93b21159ad85c843 + "--" + options.type,
            $871ea46ce85d65bc$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $871ea46ce85d65bc$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $871ea46ce85d65bc$export$93b21159ad85c843 + "--nav",
            $871ea46ce85d65bc$export$72d36ecf3758cb4b,
            !this.config.hidden && $871ea46ce85d65bc$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $871ea46ce85d65bc$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $871ea46ce85d65bc$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $871ea46ce85d65bc$var$forOwn(styles, function(value, key) {
            style += " " + $871ea46ce85d65bc$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$871ea46ce85d65bc$var$push(slides, slides);
        $871ea46ce85d65bc$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $871ea46ce85d65bc$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $871ea46ce85d65bc$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $871ea46ce85d65bc$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $871ea46ce85d65bc$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $871ea46ce85d65bc$var$SIZE + " " + $871ea46ce85d65bc$var$SIZE + '" width="' + $871ea46ce85d65bc$var$SIZE + '" height="' + $871ea46ce85d65bc$var$SIZE + '"><path d="' + (this.options.arrowPath || $871ea46ce85d65bc$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


var $e94993008cfb5130$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $e94993008cfb5130$exports) {
        classNames.default = classNames;
        $e94993008cfb5130$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $9ed9184e974deeb2$var$defaultOptions = {
    classes: {
        pagination: "ona-slider__pagination",
        page: "ona-slider__pagination-dot",
        arrows: "ona-slider__arrows"
    },
    gap: "var(--ona-slider-gap, 0)",
    arrows: false,
    pagination: false,
    drag: "free",
    autoplay: true,
    speed: 1500
};
const $9ed9184e974deeb2$export$25bca1bc22cc4f64 = (element, options = {})=>{
    const { classes: classes, extensions: extensions = {}, ...rest } = options;
    if (classes) Object.entries(classes).forEach(([key, value])=>{
        classes[key] = (0, (/*@__PURE__*/$parcel$interopDefault($e94993008cfb5130$exports)))((0, $871ea46ce85d65bc$export$24494c7438c070bf).defaults.classes?.[key] || (0, $871ea46ce85d65bc$export$ba41d43e4a419565)?.[key], $9ed9184e974deeb2$var$defaultOptions.classes?.[key], value);
    });
    return new (0, $871ea46ce85d65bc$export$24494c7438c070bf)(element, {
        ...$9ed9184e974deeb2$var$defaultOptions,
        ...rest
    }).mount(extensions);
};
document.querySelectorAll(".ona-slider[data-splide]").forEach((sliderEl)=>{
    $9ed9184e974deeb2$export$25bca1bc22cc4f64(sliderEl);
});


$087f6d04ddbb1bfe$exports = {
    "form": {
        "form-custom-select-": $84929c977c73e37d$exports,
        "gform-": $ebdfe03c08ae09ab$exports
    },
    "inline-svg": {
        "inline-svg-": $27992f293b259f68$exports
    },
    "media": {
        "media-": $155461a1578c116a$exports
    },
    "menu": {
        "menu-": $57b5d2af5de26002$exports
    },
    "parallax-container": {
        "parallax-container-": $0af0c46dafe28aa0$exports
    },
    "slider": {
        "slider-": $9ed9184e974deeb2$exports
    }
};


var $54527b80865baf83$exports = {};












$54527b80865baf83$exports = {
    "footer": {
        "footer-": {}
    },
    "form": {
        "feedback-form-": {},
        "form-custom-select-": {},
        "form-field-": {},
        "form-group-": {},
        "form-submit-button-": {},
        "gform-": {}
    },
    "inline-svg": {
        "inline-svg-": {}
    },
    "media": {
        "media-": {}
    },
    "menu": {
        "menu-": {}
    },
    "slider": {
        "slider-": {}
    },
    "wp-overrides": {
        "wp-": {}
    }
};




})();
//# sourceMappingURL=theme.bundle.js.map
